import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { SecurityService } from 'app/services/security/security.service';

@Component({
  selector: 'app-rol',
  templateUrl: './rol.component.html',
  styleUrls: ['./rol.component.scss']
})
export class RolComponent {

  IdCuenta: string;
  abrirPopUpRol: boolean = false;
  loading: boolean = false;
  constructor(private securityService: SecurityService,
    private router: Router,private loginService:LoginService) {

  }
  clickGuard(){
    this.loginService.clickGuard = true;
}
  agregarRol() {
    this.securityService.dataRol = '';
    this.abrirPopUpRol = true;
  }
  crearPopUpRol() {
    this.IdCuenta = "";
    this.abrirPopUpRol = true;
  }

  CerrarPopUpRol() {
    this.abrirPopUpRol = false;
  }

  Refresh() {
    this.router.navigate[("/rol/listado")];
  }
}
